"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CART_ITEM_SALE_SOURCE = void 0;
exports.CART_ITEM_SALE_SOURCE = {
    COLLECTION: 'COLLECTION',
    STORE: 'STORE'
};
//# sourceMappingURL=cartItemSaleSource.js.map